export default __webpack_public_path__ + "static/media/softwareDevelopment.d9b47a05.jpg";